// @react/hooks/useNotificationsTemplate.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { notificationsTemplateStore } from '@core/stores';

/**
 * React hook for NotificationTemplate operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useNotificationsTemplate } from '@react/hooks';
 *
 * const NotificationTemplateList = observer(() => {
 *   const store = useNotificationsTemplate();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useNotificationsTemplate() {
  return notificationsTemplateStore;
}
